module.exports = __webpack_public_path__ + "media/common-loon-1.49308ad4.mp3";